import React from 'react';
import withStyles from 'src/common/withStyles';

import { decorateComponent } from '../../helpers';
import Layout from '../Layout';
import LoadingSpinner from '../LoadingSpinner';
import s from './LoadingPage.module.scss';

const LoadingPage = () => (
  <Layout>
    <div className={s.root}>
      <LoadingSpinner />
    </div>
  </Layout>
);

const decorators = [
  withStyles(s),
];

export default decorateComponent(LoadingPage, decorators);
